import script from "./BrushMapContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrushMapContent.vue?vue&type=script&lang=ts&setup=true"

import "./BrushMapContent.vue?vue&type=style&index=0&id=8d881370&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d881370"]])

export default __exports__